// extracted by css-extract-rspack-plugin
export default {"Container":"En1pq","Header":"eptkF"};